import APIConnection from '@/API/APIConnection';
export default {
    get(wordId){
        return APIConnection.get(`canboard/${wordId}`);
    },
    create(wordId, seconds){
        return APIConnection.post(`canboard/${wordId}`, {seconds: seconds});
    }
}